export const applyMinimumsToPriceAndVolume = (fixedField, minimum) => {
    if (isNaN(parseFloat(minimum))) return;
    if (parseFloat(fixedField.value) < minimum) {
      fixedField.value = minimum;
    }
  };
  